module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/0ef9d47b7b000c686568d3213ee51f4a.png";